import React, { useState } from "react";
import { Modal, Input, notification } from "antd";
import SubtenantApi from "../common/Apis/SubtenantApi";

const DeleteSubTenantConfirmModal = ({ visible, subTenant, onDelete, onCancel }) => {
  const [inputCode, setInputCode] = useState("");

  const isMatch = inputCode === subTenant?.subTenantCode;

  const handleChange = (e) => setInputCode(e.target.value);

  const handleOk = () => {
    if (!isMatch) return;

    // setLoading(true);
    SubtenantApi.DeletesubtenantsApi(subTenant.id)
      .then((response) => {
        notification.success({
          message: "Deleted",
          description: `Sub Tenant "${subTenant.subTenantName}" deleted successfully.`,
          duration: 3,
          style: { backgroundColor: "#b3ffb3", color: "green" },
        });
        setInputCode("");
        // onDeleted?.(); // callback after successful delete
        onCancel(); // close modal
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Error",
          description: err?.message || "Failed to delete sub tenant.",
          duration: 3,
        });
      })
    //   .finally(() => setLoading(false));
  };

  const handleCancel = () => {
    onCancel();
    setInputCode("");
  };

  return (
    <Modal
      visible={visible}
      title={`Delete Sub Tenant "${subTenant?.subTenantName}"`}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Delete"
      okButtonProps={{ disabled: !isMatch, danger: true }}
      cancelText="Cancel"
      destroyOnClose
    >
      <p>
        To confirm deletion, please type the sub tenant code: <b>{subTenant?.subTenantCode}</b>
      </p>
      <Input
        placeholder="Enter sub tenant code here"
        value={inputCode}
        onChange={handleChange}
        autoFocus
      />
      {!isMatch && inputCode.length > 0 && (
        <p style={{ color: "red", marginTop: 8 }}>
          Sub tenant code does not match.
        </p>
      )}
    </Modal>
  );
};

export default DeleteSubTenantConfirmModal;
